import React from "react";
import { fmtPct, fmtRange } from "./stats";

// Headline numbers for the current slice. Reject rate uses TOTAL (not
// closed + discarded) as denominator: some clients act on findings without ever
// clicking "close", so "open" is not "untriaged"; explicit discards over everything
// surfaced sidestep that bias. The Wilson range says how much to trust the rate.
export default function KpiCards({ totals, basisLabel }) {
  const hasData = totals.total > 0;
  const cards = [
    {
      id: "reject-rate",
      label: "Reject Rate",
      hint: hasData
        ? `discarded ÷ total · 95% range ${fmtRange(totals.rejectLow, totals.rejectHigh)}`
        : "discarded ÷ total · the robust negative-feedback signal",
      value: hasData ? fmtPct(totals.rejectRate) : "—",
      color: "text-severity-medium",
    },
    {
      id: "confirmed-done",
      label: "Confirmed Done",
      hint: "closed ÷ total · undercounts; some clients act without closing",
      value: hasData ? fmtPct(totals.confirmedDoneRate) : "—",
      color: "text-accent-green",
    },
    {
      id: "total-issues",
      label: "Total Issues",
      hint: `${totals.discarded.toLocaleString()} discarded · ${totals.closed.toLocaleString()} closed · ${totals.open.toLocaleString()} open${
        basisLabel ? ` · window by ${basisLabel}` : ""
      }`,
      value: totals.total.toLocaleString(),
      color: "text-text-primary",
    },
  ];
  return (
    <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
      {cards.map((c) => (
        <div key={c.label} className='bg-white border border-border-subtle rounded-2xl p-4' data-testid={`kpi-${c.id}`}>
          <p className='text-body-xs text-text-secondary'>{c.label}</p>
          <p className={`text-h2 font-bold mt-1 ${c.color}`}>{c.value}</p>
          <p className='text-caption text-text-tertiary mt-1'>{c.hint}</p>
        </div>
      ))}
    </div>
  );
}
